import { StatsCard } from "@tfg/ui"
import { Link } from "react-router-dom"

import { AlertKey } from "@tfg/types/constants/alerts"

import type { AlertValueDto } from "~/gen/api"
import { useAlertMessage } from "~/pages/Brand/Home/hooks/useAlertMessage"

type Props = {
  alertValue: AlertValueDto
}

export const AlertBox = ({ alertValue: { alert, value, filter } }: Props) => {
  const alertMessage = useAlertMessage(alert.key as AlertKey)

  return (
    <Link to={`${alert.targetUrl}?${filter.params}`} target="_blank">
      <StatsCard
        description={alertMessage}
        mih="9rem"
        h="100%"
        value={value.toString()}
      />
    </Link>
  )
}
